// project imports
import React from "react";
import { Route, Routes } from "react-router";
import MinimalLayout from "./MinimalLayout";
import ProtectedRoutes from "./ProtectedRoutes";
import RouteRedirect from "./RouteRedirect";
import LoginAuth from "../Components/Auth/LoginAuth";
import Deudores from "../Components/deudores/Deudores";
import Dashboard from "../Components/Dashboard";
import ConsultaDeudor from "../Components/deudores/ConsultaDeudor";
import PrestamosPropios from "../Components/PrestamosPropios";
import Brokers from "../Components/Brokers";

const MainRoutes = () => {
  return (
    <Routes>
      <Route index element={<MinimalLayout />}></Route>
      <Route path="/login" element={<LoginAuth />}></Route>

      <Route path="/consulta/deuda/:token" element={<ConsultaDeudor />}></Route>

      <Route element={<ProtectedRoutes rol={"Administrador"} />}>
        <Route path="/dashboard" element={<Dashboard />}></Route>
        <Route path="/prestamos-caja" element={<PrestamosPropios />}></Route>
        <Route path="/deudores" element={<Deudores />}></Route>
        <Route path="/brokers" element={<Brokers />}></Route>
      </Route>

      {/* Ruta para redirigir cuando la ruta no existe */}
      <Route path="*" element={<RouteRedirect />} />
    </Routes>
  );
};

export default MainRoutes;
